import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 获取门禁进出记录列表（本地数据库）
export function listAccessControlInouts(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/property.listAccessControlInout',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        const data = res.data || {}
        resolve({
          data: data.records || [],
          total: data.total || 0
        })
      } else {
        reject(new Error(res.msg || '获取进出记录失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取门禁设备列表（本地数据库）
export function listAccessControls() {
  return new Promise((resolve, reject) => {
    request({
      url: '/property.listAccessControl',
      method: 'get',
      params: {
        page: 1,
        row: 100,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        const data = res.data || {}
        resolve({
          data: data.machineDtos || []
        })
      } else {
        reject(new Error(res.msg || '获取设备列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
